type CheckMarkSVGProps = {
    'data-testid'?: string;
};

export const CheckMarkSVG = ({
    'data-testid': dataTestId
}: CheckMarkSVGProps) => {
    return (
        <svg
            data-testid={dataTestId}
            width="16"
            height="13"
            viewBox="0 0 16 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6.21023 12.625L0.125 6.4375L2.63068 3.88971L6.21023 7.52941L13.3693 0.25L15.875 2.79779L6.21023 12.625Z"
                fill="white"
            />
        </svg>
    );
};
